module.exports = __webpack_public_path__ + "812a5296aa93237f8e13bcc8fdc261d6.png";